/** @format */

import React, { FC, ReactElement } from 'react';
import { SimpleSelect } from '../../../../components/Adescom/SimpleSelect';
import { SimCardServiceTypeItem } from '../../../../interfaces/collections/SimCardServiceInterface';
import { FeaturesAction } from '../../../../modules/features/reducers';

type SimCardTypeMappedOnProductType = {
    simCardServiceType: SimCardServiceTypeItem;
};

export const SimCardTypeMappedOnProduct: FC<SimCardTypeMappedOnProductType> = ({ simCardServiceType }): ReactElement => {
    const items = JSON.parse(simCardServiceType.configuration);
    return (
        <>
            <SimpleSelect
                selectedValue={-1}
                label={'simcard:f.param_value_label'}
                fieldName={'amount'}
                required={true}
                elements={items.values}
                dispatchName={FeaturesAction.FEATURES_ACTIVATE_WITH_PARAMETERS}
            />
        </>
    );
};
